import { apiRequest } from './client';
import type { CountPreview, CountResult, CountTarget, CountThreshold, CountThresholdMode, CreateCountInput } from '../types/inventoryCount';

// F3 · Contar por insumo. La diferencia, el bloqueo por ventas pendientes, el umbral y la fecha los
// decide el backend; la pantalla solo manda lo contado y lo que vio.
const PATH = '/api/inventory/counts';

export const getCountTarget = (storeId: string, ingredientId: string) =>
  apiRequest<CountTarget>(`${PATH}/target?storeId=${encodeURIComponent(storeId)}&ingredientId=${encodeURIComponent(ingredientId)}`);
// La comparación no escribe nada: si tarda más de 30 s se corta, para que la pantalla no quede atrapada.
export const previewCount = (input: { storeId: string; ingredientId: string; countedQuantity: number }) =>
  apiRequest<CountPreview>(`${PATH}/preview`, { ...json('POST', input), signal: timeoutSignal(30_000) });
// Igual que registrar una merma: a los 30 s se corta y la pantalla lo trata como resultado desconocido.
export const applyCount = (input: CreateCountInput) =>
  apiRequest<CountResult>(PATH, { ...json('POST', input), signal: timeoutSignal(30_000) });
export const getCountThreshold = () => apiRequest<CountThreshold>(`${PATH}/settings`);
export const setCountThreshold = (input: { mode: CountThresholdMode; value: number; uncostedPercentage?: number }) =>
  apiRequest<CountThreshold>(`${PATH}/settings`, json('PUT', input));

function json(method: string, body: unknown): RequestInit {
  return { method, body: JSON.stringify(body) };
}

function timeoutSignal(ms: number): AbortSignal | undefined {
  if (typeof AbortController === 'undefined') return undefined;
  const controller = new AbortController();
  setTimeout(() => controller.abort(), ms);
  return controller.signal;
}
